import { render, staticRenderFns } from "./ActionsStageDiscrepancies.vue?vue&type=template&id=12a31ade"
import script from "./ActionsStageDiscrepancies.vue?vue&type=script&lang=js"
export * from "./ActionsStageDiscrepancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports